import React from 'react'
import { Page } from '../components/ui/Page'
import { Body } from '../components/layout/Body';

export default function PolicyPage() {
    return (
        <div className="max-w-[1200px] mx-auto">
            <Page>
                <Body>
                    <h1 className='text-2xl mt-16 mb-8 font-bold'>Datenschutzerklärung</h1>
                    <p>Informationen gemäß Art. 13 und 14 DSGVO <br /> Plattform: <a href="https://digital-sky.jtm.digital" target="_blank" rel="noreferrer">Digital Sky</a></p>

                    <h2 className='text-lg'>1. Betreiber der Plattform</h2>
                    <p>Betreiber der Plattform „Digital Sky" und Verantwortlicher für die Verarbeitung personenbezogener Daten ist:</p>
                    <p>
                        <strong>JTM digital GmbH im Auftrag des Bundesministeriums für Finanzen (BMF)</strong><br />
                        JTM digital GmbH<br />
                        Peregringasse 2<br />
                        1090 Wien, Österreich<br />
                        Website: <a href="https://www.jtm.digital" target="_blank" rel="noreferrer">https://www.jtm.digital</a>
                    </p>
                    <p>Im Auftrag des Bundesministeriums für Finanzen (BMF), Johannesgasse 5, 1010 Wien.</p>

                    <h3>Datenschutzbeauftragter</h3>
                    <p>Den Datenschutzbeauftragten des Bundesministeriums für Finanzen erreichen Sie unter:</p>
                    <p>
                        E-Mail: <a href="mailto:datenschutz@bmf.gv.at">datenschutz@bmf.gv.at</a><br />
                        Bundesministerium für Finanzen<br />
                        Johannesgasse 5<br />
                        1010 Wien
                    </p>

                    <h2 className='text-lg'>2. Gegenstand und Zweck der Plattform</h2>
                    <p>Die Plattform „Digital Sky" (https://digital-sky.jtm.digital) dient der digitalen Abwicklung von Drohnenflügen im österreichischen Luftraum. Registrierte Nutzerinnen und Nutzer können über die Plattform Befliegungen beauftragen und verwalten.</p>

                    <h2 className='text-lg'>3. Kategorien verarbeiteter personenbezogener Daten</h2>
                    <p>Bei der Nutzung der Plattform werden personenbezogene Daten verarbeitet, soweit dies für die Vertragserfüllung erforderlich ist.</p>

                    <h3>3.1 Authentifizierungsdaten (ID Austria)</h3>
                    <p>Die Anmeldung auf der Plattform erfolgt über ID Austria, den elektronischen Identitätsnachweis der Republik Österreich. Im Rahmen der Authentifizierung werden folgende Daten verarbeitet:</p>
                    <ul className="list-disc pl-5 text-[#666]">
                        <li>Vorname und Nachname</li>
                        <li>bPK (bereichsspezifisches Personenkennzeichen)</li>
                        <li>Geburtsdatum (sofern relevant)</li>
                        <li>E-Mail-Adresse (sofern über ID Austria freigegeben)</li>
                    </ul>

                    <h3>3.2 Zahlungsdaten (Stripe)</h3>
                    <p>Für die Abwicklung von Käufen und Zahlungen wird der Zahlungsdienstleister Stripe Payments Europe, Ltd. (mit Sitz in Dublin, Irland) eingesetzt. Dabei werden folgende Daten verarbeitet:</p>
                    <ul className="list-disc pl-5 text-[#666]">
                        <li>Name des Karteninhabers / der Karteninhaberin</li>
                        <li>E-Mail-Adresse</li>
                        <li>Rechnungsadresse</li>
                        <li>Kreditkartendaten (verschlüsselt, nicht auf unseren Servern gespeichert)</li>
                        <li>Transaktionsdaten (Bestellnummer, Betrag, Zeitpunkt)</li>
                    </ul>
                    <p>Die Kreditkarten- und Zahlungsdaten werden direkt von Stripe verarbeitet und nicht auf den Servern des Bundesministeriums für Finanzen gespeichert. Stripe ist nach PCI DSS Level 1 zertifiziert.</p>
                    <p>Stripe verarbeitet personenbezogene Daten als Auftragsverarbeiter (Art. 28 DSGVO) im Auftrag des BMF.</p>
                    <p>Weitere Informationen: <a href="https://stripe.com/privacy" target="_blank" rel="noreferrer">https://stripe.com/privacy</a></p>

                    <h3>3.4 Technische Zugriffsdaten</h3>
                    <p>Beim Besuch der Plattform werden automatisch folgende technische Daten erhoben:</p>
                    <ul className="list-disc pl-5 text-[#666]">
                        <li>IP-Adresse (anonymisiert)</li>
                        <li>Datum und Uhrzeit des Zugriffs</li>
                        <li>Browsertyp und -version</li>
                        <li>Betriebssystem</li>
                        <li>Referrer-URL</li>
                    </ul>
                    <p>Diese Daten werden ausschließlich zur Sicherstellung des technischen Betriebs und der IT-Sicherheit verarbeitet. Es findet kein Tracking und keine Webanalyse statt.</p>

                    <h2 className='text-lg'>4. Cookies</h2>
                    <p>Die Plattform „Digital Sky" verwendet ausschließlich technisch notwendige Cookies, die für den Betrieb der Website und die Authentifizierung über ID Austria erforderlich sind. Es werden keine Tracking-, Analyse- oder Werbe-Cookies eingesetzt.</p>
                    <p>Die technisch notwendigen Cookies umfassen insbesondere Session-Cookies zur Aufrechterhaltung der Anmeldesitzung. Diese werden nach dem Schließen des Browsers automatisch gelöscht.</p>
                    <p>Rechtsgrundlage: § 165 Abs. 3 TKG 2021 (technisch notwendige Cookies sind ohne Einwilligung zulässig).</p>

                    <h2 className='text-lg'>5. Empfänger und Auftragsverarbeiter</h2>
                    <p>Personenbezogene Daten werden an folgende Kategorien von Empfängern weitergegeben:</p>

                    <h3>5.1 Auftragsverarbeiter</h3>
                    <ul className="list-disc pl-5 text-[#666]">
                        <li>JTM digital GmbH – technischer Betrieb und Wartung der Plattform</li>
                        <li>Stripe Payments Europe, Ltd. – Zahlungsabwicklung (teilweise als eigenständiger Verantwortlicher)</li>
                    </ul>
                    <p>Mit allen Auftragsverarbeitern bestehen Verträge gemäß Art. 28 DSGVO.</p>

                    <h3>5.2 Behördliche Weitergabe</h3>
                    <p>Soweit gesetzlich vorgesehen, können Daten an zuständige Behörden (z. B. Austro Control, Bezirksverwaltungsbehörden) weitergegeben werden, insbesondere im Rahmen luftfahrtrechtlicher Verfahren.</p>

                    <h2 className='text-lg'>6. Datenübermittlung in Drittländer</h2>
                    <p>Stripe, Inc. hat seinen Hauptsitz in den USA. Die Datenübermittlung in die USA erfolgt auf Grundlage des EU-U.S. Data Privacy Framework (Angemessenheitsbeschluss der Europäischen Kommission gemäß Art. 45 DSGVO). Stripe ist unter dem Data Privacy Framework zertifiziert.</p>
                    <p>Darüber hinaus findet keine Übermittlung personenbezogener Daten in Drittstaaten statt. Die Server der Plattform befinden sich in der Europäischen Union.</p>

                    <h2 className='text-lg'>7. Speicherdauer</h2>
                    <p>Personenbezogene Daten werden nur so lange gespeichert, wie es für die Erfüllung der jeweiligen Verarbeitungszwecke erforderlich ist oder gesetzliche Aufbewahrungspflichten bestehen:</p>
                    <ul className="list-disc pl-5 text-base text-[#666]">
                        <li>Kontodaten: Für die Dauer der Nutzung der Plattform und anschließend gemäß gesetzlicher Aufbewahrungsfristen</li>
                        <li>Zahlungsdaten: 7 Jahre gemäß § 132 BAO (Bundesabgabenordnung)</li>
                        <li>Flugdaten: Entsprechend den luftfahrtrechtlichen Aufbewahrungsfristen</li>
                        <li>Technische Zugriffsdaten: Maximal 6 Monate, danach anonymisiert</li>
                    </ul>

                    <h2 className='text-lg'>8. Ihre Rechte als betroffene Person</h2>
                    <p>Ihnen stehen gemäß DSGVO folgende Rechte zu:</p>
                    <p><strong>Recht auf Auskunft (Art. 15 DSGVO):</strong> Sie haben das Recht, Auskunft über die zu Ihrer Person gespeicherten Daten zu erhalten.
                        <br />
                        <strong>Recht auf Berichtigung (Art. 16 DSGVO):</strong> Sie haben das Recht, unrichtige Daten berichtigen zu lassen.
                        <br />
                        <strong>Recht auf Löschung (Art. 17 DSGVO):</strong> Sie haben das Recht, die Löschung Ihrer Daten zu verlangen, sofern keine gesetzlichen Aufbewahrungspflichten entgegenstehen.
                        <br />
                        <strong>Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO):</strong> Sie haben das Recht, die Einschränkung der Verarbeitung Ihrer Daten zu verlangen.
                        <br />
                        <strong>Recht auf Datenübertragbarkeit (Art. 20 DSGVO):</strong> Sie haben das Recht, Ihre Daten in einem strukturierten, gängigen und maschinenlesbaren Format zu erhalten.
                        <br />
                        <strong>Widerspruchsrecht (Art. 21 DSGVO):</strong> Sie haben das Recht, gegen die Verarbeitung Ihrer Daten, die auf Art. 6 Abs. 1 lit. e oder f DSGVO beruht, Widerspruch einzulegen.
                </p>
                    <p>Zur Ausübung Ihrer Rechte wenden Sie sich bitte an:</p>
                    <p>
                        E-Mail: <a href="mailto:datenschutz@bmf.gv.at">datenschutz@bmf.gv.at</a><br />
                        Bundesministerium für Finanzen<br />
                        Johannesgasse 5, 1010 Wien
                    </p>

                    <h2 className='text-lg'>9. Beschwerderecht bei der Aufsichtsbehörde</h2>
                    <p>Wenn Sie der Ansicht sind, dass die Verarbeitung Ihrer personenbezogenen Daten rechtswidrig erfolgt, haben Sie das Recht, Beschwerde bei der Österreichischen Datenschutzbehörde einzulegen:</p>
                    <p>
                        Österreichische Datenschutzbehörde<br />
                        Barichgasse 40–42<br />
                        1030 Wien<br />
                        Telefon: +43 (0)1 52 152-0<br />
                        E-Mail: <a href="mailto:dsb@dsb.gv.at">dsb@dsb.gv.at</a><br />
                        Website: <a href="https://www.dsb.gv.at" target="_blank" rel="noreferrer">https://www.dsb.gv.at</a>
                    </p>

                    <h2 className='text-lg'>10. Automatisierte Entscheidungsfindung</h2>
                    <p>Es findet keine ausschließlich automatisierte Entscheidungsfindung einschließlich Profiling gemäß Art. 22 DSGVO statt, die Ihnen gegenüber rechtliche Wirkung entfaltet oder Sie in ähnlicher Weise erheblich beeinträchtigt.</p>

                    <h2 className='text-lg'>11. Änderung dieser Datenschutzerklärung</h2>
                    <p>Das Bundesministerium für Finanzen behält sich vor, diese Datenschutzerklärung jederzeit anzupassen, um sie an geänderte Rechtslagen, technische Änderungen oder Änderungen der Datenverarbeitung anzupassen. Die jeweils aktuelle Fassung ist auf der Plattform abrufbar.</p>
                    <p className="text-gray-500 text-sm">Stand: März 2026</p>
                </Body>
            </Page>
        </div>
    )
}
